import { colors } from "swyft-react-core";
import { makeStyles } from "@material-ui/core";
import { fontFamily } from "../../../../app/theme";

export const quoteBoxStyles = makeStyles((theme) => ({
  root: {
    height: "100%"
  },
  productImage: {
    "maxWidth": "300px",
    "margin": "auto",
    "& img": {
      objectFit: "cover",
      width: "50%",
      height: "180px"
    }
  },
  packageTitle: {
    padding: "0 24px",
    maxWidth: "100%",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "320px",
      padding: "0",
      margin: "0 auto"
    }
  },
  button: {
    width: "90%",
    maxWidth: "17.5rem"
  },
  buttonViewQuote: {
    "width": "100%",
    "borderRadius": "28px",
    "boxShadow": "none",
    "height": "50px",
    "fontSize": "18px",
    "fontFamily": fontFamily.Axiforma,
    "fontWeight": 500,
    "& .MuiButton-label": { marginTop: "5px" },
    "&:hover": { boxShadow: "none" },
    [theme.breakpoints.down("sm")]: {
      height: "40px",
      fontSize: "16px"
    }
  }
}));

export const bannerStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: colors.primary,
    borderRadius: "8px 0 0 8px",
    color: colors.white,
    display: "flex",
    alignItems: "center",
    width: "100px",
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(-1),
    [theme.breakpoints.up("md")]: {
      width: "120px"
    }
  },
  selectedQuote: {
    width: "140px",
    [theme.breakpoints.up("md")]: {
      width: "190px"
    }
  },
  icon: {
    fontSize: "1rem",
    margin: "4px"
  }
}));
